<template>
  <div>
      <v-snackbar
      v-model="snackbar"
      :timeout="snackbar_timeout"
      color="primary"
      :top="true" >
      {{ snackbar_message }}
        </v-snackbar>
    <div class="text-center" v-if="loader">
        <v-progress-circular
        indeterminate
        color="primary"
        ></v-progress-circular>
    </div>
    <div v-else>
        <v-form
            ref="form"
            v-model="valid">
        <v-container>
            <v-row>
                <v-col
                cols="12"
                md="6"
                >
                <v-text-field
                        v-model="name"
                        label="Titre du rôle"
                        solo
                        v-validate="'required'"
                        :error-messages="errors.collect('nom')"
                        data-vv-name="nom"
                        required
                ></v-text-field>
                </v-col>

                <v-col
                cols="12"
                md="6"
                >
                <v-text-field
                    v-model="description"
                    label="Description"
                    solo
                    v-validate="'required'"
                    :error-messages="errors.collect('description')"
                    data-vv-name="description"
                    required
                ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
        <v-container>
            <v-row>
                <v-col
                cols="12"
                md="12"
                >
                    <v-card flat>
                        <v-card-title>
                            <h4 class="primary--text">Ajouter des permissions au role</h4>
                            <div v-if="selected" class="ml-4">{{ selected.length }} / {{permissions.length}} sélectionnés</div>
                        </v-card-title>
                        <v-card-text>
                            <v-container fluid>
                                <v-row>
                                    <v-col
                                        v-for="permission in permissions"
                                        :key="permission.id"
                                        class="d-flex child-flex"
                                        cols="3"
                                    >
                                    <v-card flat class="d-flex">
                                        <v-checkbox
                                            v-model="selected"
                                            :label="permission.name"
                                            :value="permission.name"
                                            :id="permission.name"
                                            color="primary"
                                            class="px-2">
                                        </v-checkbox>
                                    </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <div class="text-center pt-2">
            <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary" rounded
                @click="save()"
                v-if="$can('create roles')">
                Enregistrer
            </v-btn>
        </div>
    </v-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import axios from "axios"
import Permissions from '~/mixins/Permissions';

export default {
  name: 'settings-roles-create',
  mixins: [Permissions],
  data: () => ({
    headers: [
        { text: 'Nom de la permission', value: 'name' }
    ],
    valid: false,
    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    role: {
        name: '',
        description: '',
        permissions: []
    },
    selected: [],
    name: '',
    description: '',
    loading: false,
    loader: false,
    edit_mode: false,
    roleId: null,
    permissions: []
}),

  created () {
    this.roleId = this.$route.params.roleId
    if(this.roleId !=='new'){
        this.edit_mode = true
        this.fetchCurrentRole()
    }
    this.fetchPermissions()
  },

  computed: {
  },

  methods: {
    async fetchCurrentRole(){
        this.loader = true
        const { data } = await axios.get(`/api/roles/${this.roleId}`)
            this.name = data.name
            this.description = data.description
            this.selected = data.permissions.map(permission =>  permission.name)
            this.loader = false
    },
    async fetchPermissions(){
        this.loader = true
        const { data } = await axios.get('/api/permissions/')
        this.permissions = data
        this.loader = false
    },
    async save(){
        if (this.$refs.form.validate()) {
            // console.log(this.role)
            if (this.edit_mode) {
                this.updateRole()
            }else {
                this.createRole()
            }
        }else{
            alert('vous devez renseigner tous les champs')
        }
    },

    async createRole() {

        this.loading = true
        this.role.permissions = this.selected;
        this.role.name = this.name
        this.role.description = this.description

        await axios.post('/api/roles', this.role)
            .then(response => {
                this.snackbar = true
                this.snackbar_message = "Role ajouté avec succès!"
                this.loading = false
                this.$router.push({ name: 'settings.roles'})
                })
            .catch(err => {
                console.log(' Role creation error ', err)
                this.loading = false
                })
    },

    async updateRole() {

        this.loading = true
        this.role.permissions = this.selected;
        this.role.name = this.name
        this.role.description = this.description

        await axios.put(`/api/roles/${this.roleId}`, this.role)
            .then(response => {
                this.snackbar = true
                this.snackbar_message = "Role modifié avec succès!"
                this.loading = false
                this.$router.push({ name: 'settings.roles'})
                })
            .catch(err => {
                console.log(' Role modification error ', err)
                this.loading = false
                })
    }
  }
};
</script>
<style>
thead{
  background-color: #78B943;
}
thead th{
  color: #fff !important;
}

thead th i{
  color: #fff !important;
}

.v-data-table td, .v-data-table th {
    padding: 0 5px;
    font-size: 16px;
}

.v-data-table th {
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/roles/create.vue